module.exports = __webpack_public_path__ + "img/italy-colorectal-cancer-female.22178a2f.png";